<template>
  <div class="sc-message" :class="{ fullscreen: isFullScreen }" v-if="hideMessage === false">
    <div class="sc-message--content" :class="{
        sent: message.author === 'me',
        received: message.author !== 'me' && message.type !== 'system',
        system: message.type === 'system'
      }">

      <div v-if="message.type !== 'system'" :title="chatbotName" class="sc-message--avatar">
        <img :src="chatbotImage" :alt="chatbotName" v-tooltip="chatbotName" />
      </div>

      <TextMessage
        v-if="message.type === 'text'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <ButtonsMessage
        v-if="message.type === 'buttons'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <ChoiceMessage
        v-if="message.type === 'choice'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <ChoiceAjaxMessage
        v-if="message.type === 'choice_ajax'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <MultipleSelectionsMessage
        v-if="message.type === 'multiple_selections'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <LifeInsuranceCalculationsMessage
        v-if="message.type === 'life_insurance_calculations'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <LifeInsuranceCalculationsInfocapMessage
        v-if="message.type === 'life_insurance_calculations_infocap'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <PersonalAccidentInsuranceCalculationsMessage
        v-if="message.type === 'personal_accident_insurance_calculations'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <IncomeLossInsuranceCalculationMessage
        v-if="message.type === 'income_loss_insurance_calculation'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <ProfessionalProtectionInsuranceCalculationMessage
        v-if="message.type === 'professional_protection_insurance_calculations'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <VehicleInsuranceCalculationsMessage
        v-if="message.type === 'vehicle_insurance_calculations'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <VehicleInsuranceCalculations2Message
        v-if="message.type === 'vehicle_insurance_calculations2'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <VehicleInsuranceCalculationsWithAdjustCoverageMessage
        v-if="message.type === 'vehicle_insurance_calculations_with_adjust_coverage'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <VehicleInsuranceCalculationsInfocapMessage
        v-if="message.type === 'vehicle_insurance_calculations_infocap'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <ResidentialInsuranceCalculationsMessage
        v-if="message.type === 'residential_insurance_calculations'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <ResidentialInsuranceCalculationsInfocapMessage
        v-if="message.type === 'residential_insurance_calculations_infocap'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <AgeRangesApprovitaMessage
        v-if="message.type === 'age_ranges_approvita'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <HealthPlanCalculationsApprovitaMessage
        v-if="message.type === 'health_plan_calculations_approvita'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <OdontologyPlanCalculationsApprovitaMessage
        v-if="message.type === 'odontology_plan_calculations_approvita'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <HealthPlanCalculationsSimplemedMessage
        v-if="message.type === 'health_plan_calculations_simplemed'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <BikePlanCalculationsGenteSeguradoraMessage
        v-if="message.type === 'bike_insurance_calculations_gente_seguradora'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <InsuranceCalculationsYupinMessage
        v-if="message.type === 'insurance_calculations_yupin'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <CertificateYupinMessage
        v-if="message.type === 'certificate_yupin'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <VehicleInsuranceCalculationsSuhaiMessage
        v-if="message.type === 'vehicle_insurance_calculations_suhai'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <SaluapLifeInsuranceCalculationsMessage
        v-if="message.type === 'saluap_life_insurance_calculations'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <SaluapPersonalAccidentInsuranceCalculationsMessage
        v-if="message.type === 'saluap_personal_accident_insurance_calculations'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <AgeRangesRoseLifeMessage
        v-if="message.type === 'age_ranges_roselife'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <HealthPlanCalculationsRoseLifeMessage
        v-if="message.type === 'health_plan_calculations_roselife'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <InsuranceCalculationsArgoRcAdvogadosPfYupinMessage
        v-if="message.type === 'insurance_calculations_argo_rc_advogados_pf_yupin'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <InsuranceCalculationsEqSegurosYupinMessage
        v-if="message.type === 'insurance_calculations_eqseguros_yupin'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <InsuranceCalculationsFiancaMessage
        v-if="message.type === 'insurance_calculations_fianca'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <AgeRangesHapvidaRvMessage
        v-if="message.type === 'age_ranges_hapvida_rv'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <HealthPlanCalculationsHapvidaRvMessage
        v-if="message.type === 'health_plan_calculations_hapvida_rv'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <FuneralMessage
        v-if="message.type === 'funeral'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <AssistsMessage
        v-if="message.type === 'assists'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <ValuesMessage
        v-if="message.type === 'values'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <WhatsAppMessage
        v-if="message.type === 'whatsapp'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <TableMessage
        v-if="message.type === 'table'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <HtmlMessage
        v-if="message.type === 'html'"
        :message="message"
        :messageColors="determineMessageColors()"
        :messageStyling="messageStyling"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <TypingMessage
        v-else-if="message.type === 'typing'"
        :messageColors="determineMessageColors()"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />

      <SystemMessage
        v-else-if="message.type === 'system'"
        :data="message.data"
        :messageColors="determineMessageColors()"
        :chatbotColors="chatbotColors"
        :lastMessage="lastMessage"
        @hideMessage="onHideMessage" />
    </div>
  </div>
</template>

<script>
import TextMessage from './messages/TextMessage.vue'
import ButtonsMessage from './messages/ButtonsMessage.vue'
import ChoiceMessage from './messages/ChoiceMessage.vue'
import ChoiceAjaxMessage from './messages/ChoiceAjaxMessage.vue'
import MultipleSelectionsMessage from './messages/MultipleSelectionsMessage.vue'
import LifeInsuranceCalculationsMessage from './messages/LifeInsuranceCalculationsMessage.vue'
import LifeInsuranceCalculationsInfocapMessage from './messages/LifeInsuranceCalculationsInfocapMessage.vue'
import PersonalAccidentInsuranceCalculationsMessage from './messages/PersonalAccidentInsuranceCalculationsMessage.vue'
import IncomeLossInsuranceCalculationMessage from './messages/IncomeLossInsuranceCalculationMessage.vue'
import ProfessionalProtectionInsuranceCalculationMessage from './messages/ProfessionalProtectionInsuranceCalculationMessage.vue'
import VehicleInsuranceCalculationsMessage from './messages/VehicleInsuranceCalculationsMessage.vue'
import VehicleInsuranceCalculations2Message from './messages/VehicleInsuranceCalculations2Message.vue'
import VehicleInsuranceCalculationsWithAdjustCoverageMessage from './messages/VehicleInsuranceCalculationsWithAdjustCoverageMessage.vue'
import VehicleInsuranceCalculationsInfocapMessage from './messages/VehicleInsuranceCalculationsInfocapMessage.vue'
import ResidentialInsuranceCalculationsMessage from './messages/ResidentialInsuranceCalculationsMessage.vue'
import ResidentialInsuranceCalculationsInfocapMessage from './messages/ResidentialInsuranceCalculationsInfocapMessage.vue'
import AgeRangesApprovitaMessage from './messages/AgeRangesApprovitaMessage.vue'
import HealthPlanCalculationsApprovitaMessage from './messages/HealthPlanCalculationsApprovitaMessage.vue'
import OdontologyPlanCalculationsApprovitaMessage from './messages/OdontologyPlanCalculationsApprovitaMessage.vue'
import HealthPlanCalculationsSimplemedMessage from './messages/HealthPlanCalculationsSimplemedMessage.vue'
import BikePlanCalculationsGenteSeguradoraMessage from './messages/BikePlanCalculationsGenteSeguradoraMessage.vue'
import InsuranceCalculationsYupinMessage from './messages/InsuranceCalculationsYupinMessage.vue'
import CertificateYupinMessage from './messages/CertificateYupinMessage.vue'
import VehicleInsuranceCalculationsSuhaiMessage from './messages/VehicleInsuranceCalculationsSuhaiMessage.vue'
import SaluapLifeInsuranceCalculationsMessage from './messages/SaluapLifeInsuranceCalculationsMessage.vue'
import SaluapPersonalAccidentInsuranceCalculationsMessage from './messages/SaluapPersonalAccidentInsuranceCalculationsMessage.vue'
import AgeRangesRoseLifeMessage from './messages/AgeRangesRoseLifeMessage.vue'
import HealthPlanCalculationsRoseLifeMessage from './messages/HealthPlanCalculationsRoseLifeMessage.vue'
import InsuranceCalculationsArgoRcAdvogadosPfYupinMessage from './messages/InsuranceCalculationsArgoRcAdvogadosPfYupinMessage.vue'
import InsuranceCalculationsEqSegurosYupinMessage from './messages/InsuranceCalculationsEqSegurosYupinMessage.vue'
import InsuranceCalculationsFiancaMessage from './messages/InsuranceCalculationsFiancaMessage.vue'
import AgeRangesHapvidaRvMessage from './messages/AgeRangesHapvidaRvMessage.vue'
import HealthPlanCalculationsHapvidaRvMessage from './messages/HealthPlanCalculationsHapvidaRvMessage.vue'
import FuneralMessage from './messages/FuneralMessage.vue'
import AssistsMessage from './messages/AssistsMessage.vue'
import ValuesMessage from './messages/ValuesMessage.vue'
import WhatsAppMessage from './messages/WhatsAppMessage.vue'
import TableMessage from './messages/TableMessage.vue'
import HtmlMessage from './messages/HtmlMessage.vue'
import TypingMessage from './messages/TypingMessage.vue'
import SystemMessage from './messages/SystemMessage.vue'

export default {
  components: {
    TextMessage,
    ButtonsMessage,
    ChoiceMessage,
    ChoiceAjaxMessage,
    MultipleSelectionsMessage,
    LifeInsuranceCalculationsMessage,
    LifeInsuranceCalculationsInfocapMessage,
    PersonalAccidentInsuranceCalculationsMessage,
    IncomeLossInsuranceCalculationMessage,
    ProfessionalProtectionInsuranceCalculationMessage,
    VehicleInsuranceCalculationsMessage,
    VehicleInsuranceCalculations2Message,
    VehicleInsuranceCalculationsWithAdjustCoverageMessage,
    VehicleInsuranceCalculationsInfocapMessage,
    ResidentialInsuranceCalculationsMessage,
    ResidentialInsuranceCalculationsInfocapMessage,
    AgeRangesApprovitaMessage,
    HealthPlanCalculationsApprovitaMessage,
    OdontologyPlanCalculationsApprovitaMessage,
    HealthPlanCalculationsSimplemedMessage,
    BikePlanCalculationsGenteSeguradoraMessage,
    InsuranceCalculationsYupinMessage,
    CertificateYupinMessage,
    VehicleInsuranceCalculationsSuhaiMessage,
    SaluapLifeInsuranceCalculationsMessage,
    SaluapPersonalAccidentInsuranceCalculationsMessage,
    AgeRangesRoseLifeMessage,
    HealthPlanCalculationsRoseLifeMessage,
    InsuranceCalculationsArgoRcAdvogadosPfYupinMessage,
    InsuranceCalculationsEqSegurosYupinMessage,
    InsuranceCalculationsFiancaMessage,
    AgeRangesHapvidaRvMessage,
    HealthPlanCalculationsHapvidaRvMessage,
    FuneralMessage,
    AssistsMessage,
    ValuesMessage,
    WhatsAppMessage,
    TableMessage,
    HtmlMessage,
    TypingMessage,
    SystemMessage
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotName: {
      type: String,
      required: true
    },
    chatbotImage: {
      type: String,
      default: ''
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      hideMessage: false
    }
  },
  computed: {
    isFullScreen () {
      return this.$store.getters.isFullScreen;
    }
  },
  mounted () {
    if (this.message.hideMessage) {
      this.onHideMessage();
    }
  },
  methods: {
    sentColorsStyle() {
      return {
        color: this.chatbotColors.sentMessage.text,
        backgroundColor: this.chatbotColors.sentMessage.bg
      }
    },
    receivedColorsStyle() {
      return {
        color: this.chatbotColors.receivedMessage.text,
        backgroundColor: this.chatbotColors.receivedMessage.bg
      }
    },
    determineMessageColors() {
      return this.message.author === 'me' ? this.sentColorsStyle() : this.receivedColorsStyle()
    },
    onHideMessage () {
      this.hideMessage = true;
    }
  }
}
</script>
<style lang="scss">
.sc-message {
  width: 88%;
  margin: auto;
  padding-bottom: 10px;
  display: flex;
}

.sc-message--content {
  width: 100%;
  display: flex;
}

.sc-message--content.sent {
  justify-content: flex-end;
}

.sc-message--content.system {
  justify-content: center;
}

.sc-message--content.sent .sc-message--avatar {
  display: none;
}

.sc-message--avatar {
  display: flex;
  align-items: center;
  margin-right: 8px;

  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
}

.sc-message--meta {
  font-size: xx-small;
  margin-bottom: 0px;
  color: white;
  text-align: center;
}

/* FULLSCREEN */
@media (min-width: 450px) {
  .sc-message.fullscreen {
    max-width: 800px;
  }
}

.sc-message--text {
  display: inline-block;
  padding: 10px 15px;
  border-radius: 20px;
  /* font-weight: 300; */
  font-size: 14px;
  line-height: 1.4;
  position: relative;
  -webkit-font-smoothing: subpixel-antialiased;

  .sc-message--text-content{
    margin: 0;
  }
  .sc-message--text-body{
    .sc-message--text-content{
      white-space: pre-wrap;
    }
  }
  &:hover .sc-message--toolbox{
    left: -20px;
    opacity: 1;
  }
  .sc-message--toolbox{
    transition: left 0.2s ease-out 0s;
    white-space: normal;
    opacity: 0;
    position: absolute;
    left: 0px;
    width: 25px;
    top: 0;
    button {
      background: none;
      border: none;
      padding: 0px;
      margin: 0px;
      outline: none;
      width:100%;
      text-align: center;
      cursor: pointer;
      &:focus {
        outline: none;
      }
    }
  }
}
.sc-message--content.sent .sc-message--text {
  color: white;
  background-color: #4e8cff;
  max-width: calc(100% - 120px);
  word-wrap: break-word;
}

.sc-message--text code {
  font-family: 'Courier New', Courier, monospace !important;
}

.sc-message--content.received .sc-message--text {
  color: #263238;
  background-color: #f4f7f9;
  margin-right: 40px;
  position: relative;
}

.tooltip {
  display: block !important;
  z-index: 10000;
  font-size: .8rem;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }
  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }
  &[x-placement^="top"] {
    margin-bottom: 5px;
    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="bottom"] {
    margin-top: 5px;
    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="right"] {
    margin-left: 5px;
    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[x-placement^="left"] {
    margin-right: 5px;
    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }
  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
  &.info {
    $color: rgba(#004499, .9);
    .tooltip-inner {
      background: $color;
      color: white;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }
    .tooltip-arrow {
      border-color: $color;
    }
  }
  &.popover {
    $color: #f9f9f9;
    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }
    .popover-arrow {
      border-color: $color;
    }
  }
}
</style>
